// react-frontend/src/admin/bookings/AssignedBookings.js
import React from 'react';
import AllBookings from './AllBookings';

const AssignedBookings = () => {
  return <AllBookings defaultTab="assigned" />;
};

export default AssignedBookings;